import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

interface PopupModalProps {
  imageUrl: string;
  targetUrl: string;
}

const PopupModal: React.FC<PopupModalProps> = ({ imageUrl, targetUrl }) => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 初回は5秒後に表示
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    }, 15000);

    // その後15秒ごとに表示
    const intervalTimer = setInterval(() => {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    }, 60000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
      document.body.style.overflow = '';
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    document.body.style.overflow = '';
  };

  const handleImageClick = () => {
    navigate(targetUrl);
    document.body.style.overflow = '';
  };

  if (!isVisible) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modal__backdrop} onClick={handleClose} />
      <div className={styles.modal__content}>
        <button className={styles.modal__close} onClick={handleClose} aria-label="閉じる">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <img
          src={imageUrl}
          alt="かまた祭2025へ移動"
          className={styles.modal__image}
          onClick={handleImageClick}
        />
      </div>
    </div>
  );
};

export default PopupModal;
